import { MetadataModules } from '../enums/index.js';
import { addAddProvider } from '../metaData.js';
import { addWritableCacheForType } from '../utilities/metadataProvider/cacheData.js';
function displaySetAddProvider(next, query, _data, options) {
    const displaySet = options?.displaySet;
    if (displaySet) {
        return displaySet;
    }
    return next(query, _data, options);
}
export function registerDisplaySetProviders() {
    addWritableCacheForType(MetadataModules.DISPLAY_SET);
    addAddProvider(MetadataModules.DISPLAY_SET, displaySetAddProvider, {
        priority: 40_000,
    });
}
